export default "__VITE_ASSET__CMw3Xx6B__"